import { gql, useQuery } from "@apollo/client";
import useRequestConfig from "src/utils/hook/base/useRequestConfig";

const Q_GetActiveSubscription = gql`
  query ActiveSubscription {
    activeSubscription {
      endDate
      extensionDeadline
      remainingDays
      plan {
        title
        id
      }
    }
  }
`;

function useGetActiveSubscription(permission) {
  const { requestConfig } = useRequestConfig();
  const { loading, error, data, refetch } = useQuery(
    Q_GetActiveSubscription,
    requestConfig({
      module: "AVC_AAA",
      Microservice: permission,
    })
  );
  return { data, error, loading, refetch };
}
export default useGetActiveSubscription;
